import { RpcException } from "@/core/rpc-mp-provider/exceptions/RpcException.ts";

export class RpcNotFoundException extends RpcException {}
